import Rest from './Rest';

const Settlement = {
  fetchBaseInfo: () => {
    return Rest.get('/dushu/provider/settle-accounts');
  },

  withdraw: (params) => {
    return Rest.post('/dushu/provider/settle-account/withdraw', params);
  },

  fetchTransactions: (params) => {
    return Rest.get('/dushu/provider/settle-account/transactions', { params });
  },

  fetchReport: () => {
    return Rest.get('/dushu/provider/report/settlement-report');
  },

  updateSettings: (params) => {
    return Rest.put('/dushu/provider/settle-account/settings', params);
  }
}

export default Settlement;